var Unlock = require('RecordUnlock');
var MultiTab = require('MultiTab');
var StatusType = EY.Consultation.Lookups.StatusType;
var User = EY.Consultation.CurrentUser;
var Configuration = EY.Consultation.Lookups.Configuration;
var RecordDocumentationSync = require('RecordDocumentationSync');

var access = function (options) {
    var record = options.record;
    var lockedBy = record.get('lockedBy');
    var lockedOn = new Date(record.get('lockedOn'));
    var now = new Date();
    var geography = record.get('geographyTypePath') === '/Area/Region/Country/SubCountry/' || record.get('geographyTypePath') === '/Area/Region/Country/Office/' ? record.get('countryId') : record.get('geographyId');
    var geographyRegExp = new RegExp(geography.replace(/\//g, '\\/'), 'g');
    var geographyIdRegExp = new RegExp(record.get('geographyId').replace(/\//g, '\\/'), 'g');
    var rights = record.get('statusTypeId') !== StatusType.UsersNotified &&
        (record.get('assignedTo') === User.upn || geographyRegExp.test(User.geographyByRole['CountryAdministrator']) || geographyIdRegExp.test(User.geographyByRole['RegionAdministrator']));

    return rights && (!lockedBy || new Date(lockedOn.getTime() + Configuration.SessionTimeout) < now);
};

var save = function (options) {
    var history = options.history;
    var record = options.record;

    record.save(history, { validate: false });
};

var lock = function (options) {
    var history = options.history;
    var record = options.record;

    record.set('lockedBy', User.upn);
    record.set('lockedByGivenName', User.givenName);
    record.set('lockedOn', new Date());
    history.lockedBy = User.upn;
    history.lockedByGivenName = User.givenName;
    history.lockedOn = new Date();
    if (history.id) {
        save(options);
    }
};

var unlock = function (options) {
    var history = options.history;
    var record = options.record;
    var recordId = new RegExp(record.id);
    RecordDocumentationSync.validateAttachments(options).done(function(corruptedAttachments) {
        var isAttachmentCorrupted = corruptedAttachments.length > 0 ? true : false;
        if (!recordId.test(window.location.href) && record.get('lockedBy') === User.upn && !isAttachmentCorrupted && history.id && record.get('action') !== 'delete') {
            Unlock.run(options);
            save(options);
        }
    });
};

module.exports.start = function (options) {
    var session = User.session;
    var view = options.view;
    var record = options.record;
    var reset = function () { 
        this.inactive() >= Configuration.SessionTimeout ? unlock(options) : lock(options); 
    };
    var handleUnload = function () {
        Unlock.run(options);
        save(options);
    };

    if (access(options)) {
        lock(options);
        session.on('change:time', reset);
    } else if(MultiTab.isOpeningInMultiTab({
        lockedBy: record.get('lockedBy'),
        isOpenedByCurrentUser: record.get('isOpenedByCurrentUser')
    })) {
        record.set("isOpenedByCurrentUser", true);
        record.save(record, { validate: false });
    }
    
    view.on('destroy', function () {
        unlock(options);
        session.off('change:time', reset);
        window.removeEventListener('beforeunload', handleUnload);
    });
    
    if(Configuration.MultiTabCheckForCurrentUser && record.id) {
        window.addEventListener('beforeunload', handleUnload);
    }
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Service/RecordLock.js